// extracted by mini-css-extract-plugin
export default {"maxWidth":"kioskFooter_maxWidth__0h9ka"};